import {AbstractDTO} from "@signature-it/ngx-generic/models";

export class PageRelatedMediaPreviewEntityConfig extends AbstractDTO{
    entityVar: string;
    relatedItemSolrKey: string;
    relatedEntityVarList: Array<string>;
    entityPreviewVar: string;
    responsive: {};

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        this.relatedItemSolrKey  = attributes['relatedItemSolrKey'] || '';
        this.entityPreviewVar = attributes['entityPreviewVar'] || '';
        this.responsive = attributes['responsive'] ||{};
    }
}
